
const BASE_URL = "https://app.radheshyamtravels.com/";
// http://localhost:3000/
// https://radheshyamtravels.com/

// https://app.radheshyamtravels.com/
export default BASE_URL;
